import { get } from 'lodash'

export default (data, pathToField) => {
  const value = get(data, pathToField)

  return value || '<span style="color: #ccc">&mdash;</span>'
}
